import React, { useEffect, useRef, useState, useContext, createContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import BladeModels from './BladeModels';
import Hubs from './Hubs';
import GADrawings from './GADrawings';
import OctaveBands from './OctaveBands';
import FanDetails from './FanDetails';
import { Button, Container, Grid, Paper, Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    radioGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    formControl: {
      width: '100%',
    },
    radioWrapped: {
      marginLeft: theme.spacing(2),
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    redOutline: {
      borderColor: "red !important"
    },
    uppercaseText: {
      textTransform: 'uppercase'
    },
    wrapperOverflow: {
      overflow: 'auto',
      marginTop: '-70px'
    }
  }),
);

export interface FanUploadProps {
  setIndex?: Function;
  index?: number;
  modelId?: string;
  gaDrawingID?: string;
  octaveBandID?: string
  hubID?: string;
  setVisibleModule?: Function
  selectedFan?: any;
  fanAction?: any;
  handleRefresh?: any;
  userUpdatedData?:any,
  isFromFanList?: boolean,
  footerDisable: Function,
  hubDiameter?: any, // <-- added this line
  setHubDiameter?: React.Dispatch<any>; // <-- add this line
  onBack?: () => void;
  onNext?: () => void;
  onUpdate?: () => void;
  callBackSubmit?: () => void
}

interface LocationState {
  selectedFan?: any;
  fanAction?: any;
}

/*interface MyData {
  id: number;
  name: string;
}
export const MyDataContext = createContext<{ data: MyData[]; setData: React.Dispatch<React.SetStateAction<MyData[]>> }>({
  data: [],
  setData: () => { },
});

export const MyDataProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<MyData[]>([]);

  return (
    <MyDataContext.Provider value={{ data, setData }}>
      {children}
    </MyDataContext.Provider>
  );
};

export const useMyData = () => {
  return useContext(MyDataContext);
};
const { data, setData } = useContext(MyDataContext)*/


export const MyFooterAction = ({ onBack, onNext, index, fanAction }: FanUploadProps) => {
  const classes = useStyles();
  const history = useHistory();
  const onNextCall = () => {
    if (onNext) {
      onNext();
    }
  }
  const onBackCall = () => {
    if (index == 1) {
      debugger
      history.push('/search');
      return false;
    } else if (onBack) {
      onBack();
    }
  }

  return (
    <div className='page-wrapper-footer'>
      <Container maxWidth="xl">
        <Paper className={`form-wrapper ${classes.wrapperOverflow}`}>
          <Grid item xs={12} lg={12}>
          {index && index != 5 &&
              <><Button style={{backgroundColor:'#6b6666'}}  variant="contained" color="primary" onClick={onBackCall} className={classes.radioWrapped}> Back</Button>
              <Button variant="contained" color="primary" onClick={onNextCall} className={classes.radioWrapped}> Next</Button>
              </>
            }
          </Grid>
        </Paper>
      </Container>
    </div>
  )
}

const FanUpload: React.FC<FanUploadProps> = () => {
  const location = useLocation<LocationState>();
  const { selectedFan, fanAction } = location.state || {};
  console.log(selectedFan)
  const selectedModelId = selectedFan?.bladeModel?.bladeModelID;
  const selectedHubID = selectedFan?.hub.hubID;
  const selectedGaDrawingID = selectedFan?.gaDrawing.gaDrawingID;
  const selectedOctaveBandID = selectedFan?.octaveBand.octaveBandID;
  
  const selectedHubDiameter = selectedFan?.hub.hubDiameter;

  const classes = useStyles();
  const [index, setIndex] = React.useState(1);
  const [modelId, setVisibleModule] = React.useState(selectedModelId);
  const [hubID, setVisibleHubID] = React.useState(selectedHubID);
  const [gaDrawingID, setVisibleGaDrawingID] = React.useState(selectedGaDrawingID);
  const [octaveBandID, setVisibleOctaveBandID] = React.useState(selectedOctaveBandID);
  const [disableFooter,setDisableFooter] = React.useState(false);
  const [hubDiameter, setHubDiameter] = React.useState(selectedHubDiameter);

  const handleNext = (value: any) => {
    setIndex(value);
  };

  const handleRefresh = (value: any) => {
    setIndex(value)
  }


    return (
    <>
      {index == 1 && <BladeModels setIndex={handleNext} modelId={modelId} setVisibleModule={setVisibleModule} isFromFanList={true} footerDisable={setDisableFooter} />}
      {index == 2 && (
        <Hubs
          setIndex={handleNext}
          hubID={hubID}
            //setVisibleModule={setVisibleHubID}
            setVisibleModule={(data: { hubID: string; hubDiameter: number }) => {
            setVisibleHubID(data.hubID);
            setHubDiameter(data.hubDiameter);
            }}
            hubDiameter={hubDiameter as number} // <-- add this prop
            setHubDiameter={setHubDiameter} // <-- Pass the setter
  
          handleRefresh={handleRefresh}
          isFromFanList={true}
          footerDisable={setDisableFooter}
        />
      )}
      {index == 3 && <OctaveBands setIndex={handleNext} octaveBandID={octaveBandID} setVisibleModule={setVisibleOctaveBandID} isFromFanList={true} footerDisable={setDisableFooter} />}
      {index == 4 && <GADrawings setIndex={handleNext} gaDrawingID={gaDrawingID} setVisibleModule={setVisibleGaDrawingID} isFromFanList={true} footerDisable={setDisableFooter} selectedFan={selectedFan}/>}
      {index == 5 && (
        <FanDetails
          setIndex={handleNext}
          modelId={modelId}
          setVisibleModule={setVisibleOctaveBandID}
          selectedFan={selectedFan}
          userUpdatedData={{
            modelId,
            hubID,
            gaDrawingID,
            octaveBandID,
            hubDiameter 
          }}
          footerDisable={setDisableFooter}
        />
      )}
      {!disableFooter && <MyFooterAction onNext={() => setIndex(index + 1)} onBack={() => setIndex(index - 1)} index={index} fanAction={fanAction} footerDisable={setDisableFooter} />}
      
    </>
  );
};

export default FanUpload